/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
import PromotionsSlider from './PromotionsSlider';
import PaginationComponent from '../../../common/pagination/Pagination';
import Placeholder from '../../../common/placeholder/Placeholder';
import Button from '../../../common/button/Button';

const A1MEDIA_MEDIUM_UP = 'https://a1media.antena1.com.br/image/promocao/482x250/';
const A1MEDIA_SMALL_DOWN = 'https://a1media.antena1.com.br/image/promocao/560x292/';


class Promotions extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            isMobile: false,
            hasMounted: false,
        };

        this._getMoreClosedPromotions = this._getMoreClosedPromotions.bind(this);
    }

    componentDidMount() {
        this.props.fetchAllPublishedPromotionsIfNeeded();

        const promotionsPerPage = this.state.isMobile ? 4 : 8;
        const totalPromotionsToFetch = promotionsPerPage * 5;

        this.props.fetchClosedPromotionsIfNeeded(totalPromotionsToFetch, 0);

        const isMobile = window.innerWidth <= 768

        this.setState({ isMobile, hasMounted: true });

        animateScrollTo(0, { speed: 700 });

        window.addEventListener('resize', this._handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._handleResize);
    }

    _handleResize = () => {
        const isMobile = window.innerWidth <= 768;

        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile });
        }
    };

    // eslint-disable-next-line react/sort-comp
    _showClosedPromotions() {
        const { closedPromotions } = this.props;
        const { currentPage, isMobile } = this.state;

        const promotionsPerPage = isMobile ? 4 : 8;
        const startIndex = (currentPage - 1) * promotionsPerPage;
        const endIndex = startIndex + promotionsPerPage;

        const paginatedPromotions = closedPromotions.slice(startIndex, endIndex);

        const breakpoint = this.state.hasMounted ? this.props.breakpoint : this.props.breakpoint.serverBreakPoints;

        return paginatedPromotions.map((item, index) => {
            const realIndex = index + 1;
            const showBanner = realIndex % 6 === 0;
            // DEFINE IMAGE PATH
            let a1mediaPath;
            let pathImage;

            if (item.tx_imageNew) {
                // Define a1Media path to new promotion
                breakpoint.width < 768 ? a1mediaPath = A1MEDIA_SMALL_DOWN
                    : a1mediaPath = A1MEDIA_MEDIUM_UP;

                pathImage = item.tx_imageNew;
            } else {
                // define a1Media path to old promotion
                a1mediaPath = 'https://a1media.antena1.com.br/image/promocao/';

                pathImage = item.tx_banner;
            }

            // show description in tablet
            const showContentStyle = this.props.isTablet != null ? { opacity: '1 !important' } : {};

            return (
                showBanner ?
                    [
                        <Button key={item.id_promocao} className="wrapperPromotions" to={`/promocoes/${item.url_promocao}`} title={`Saiba mais sobre ${item.tx_promocao}`}>
                            <div className="tw-h-12">
                                <p className="tw-text-black tw-text-lg tw-font-bold limitText2">
                                    {item.tx_promocao}
                                </p>
                            </div>
                            <div style={showContentStyle} className="singlePromotion" key={realIndex}>
                                <img src={a1mediaPath + pathImage} alt={item.tx_promocao} className="tw-h-44 tw-w-full" />

                                <div style={showContentStyle} className="shadow" />
                            </div>
                        </Button>,
                        // <Banner key={`Publicidade ${realIndex}`} config={multiMultiBannerConfig} />,
                    ]
                    :
                    <Button key={item.id_promocao} className="wrapperPromotions" to={`/promocoes/${item.url_promocao}`} title={`Saiba mais sobre ${item.tx_promocao}`}>
                        <div className="tw-h-12">
                            <p className="tw-text-black tw-text-lg tw-font-bold limitText2">
                                {item.tx_promocao}
                            </p>
                        </div>
                        <div style={showContentStyle} className="singlePromotion" key={realIndex}>
                            <img src={a1mediaPath + pathImage} alt={item.tx_promocao} className="tw-h-44 tw-w-full" />
                            <div style={showContentStyle} className="shadow" />
                        </div>
                    </Button>
            );
        });
    }

    _getMoreClosedPromotions() {
        const promotionsPerPage = this.state.isMobile ? 4 : 8;
        const start = this.props.closedPromotions.length;

        this.props.fetchClosedPromotionsIfNeeded(promotionsPerPage * 5, start);
    }

    _handlePageChange = (pageNumber) => {
        this.setState({ currentPage: pageNumber }, () => {
            animateScrollTo(0, { speed: 700 });
        });
    };

    _handleNext = () => {
        const { currentPage, isMobile } = this.state;
        const promotionsPerPage = isMobile ? 4 : 8;
        const totalPages = Math.ceil(this.props.closedPromotions.length / promotionsPerPage);

        if (currentPage < totalPages) {
            this.setState({ currentPage: currentPage + 1 }, () => {
                animateScrollTo(0, { speed: 700 });
            });
        }
    };

    _handlePrev = () => {
        const { currentPage } = this.state;

        if (currentPage > 1) {
            this.setState({ currentPage: currentPage - 1 }, () => {
                animateScrollTo(0, { speed: 700 });
            });
        }
    };

    render() {
        return (
            <section className="promotions">
                <header>
                    <h1>Promoções</h1>
                    <p>
                        Confira as promoções que estão acontecendo no momento
                    </p>
                </header>

                {!this.props.allPublishedPromotions ?
                    <div className="mb-4">
                        <Placeholder minHeight="400px" />
                    </div>
                    :
                    this.props.allPublishedPromotions.length === 0 ?
                        <div className="noPromotions">
                            Não há promoções no momento
                        </div>
                        :
                        <div className="featuredPromotions">
                            {
                                this.props.featuredPromotions.length > 0 &&
                                    <PromotionsSlider
                                        promotions={this.props.featuredPromotions}
                                        slidesToShowExtraSmall={1}
                                        slidesToShowSmall={1}
                                        slidesToShowMedium={1}
                                        slidesToShowExtraLarge={1}
                                        navigation={false}
                                        slidesToShowLarge={1}
                                        fullVersion
                                        pagination={this.props.featuredPromotions.length > 1}
                                        infinite={false}
                                    />
                            }
                            {/* Hidden while no promotion is active — re-enable when a new "Ouça e Concorra" edition launches
                            <h6 className="tw-text-xl md:tw-text-3xl tw-font-bold">
                                NÃO FIQUE DE FORA! PARTICIPE DA PROMOÇÃO "OUÇA E CONCORRA"
                            </h6>
                            */}
                        </div>}
                <div className="closedPromotions tw-container tw-m-auto">
                    <header className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-border-t tw-border-b tw-border-black tw-py-4 tw-px-0">
                        <h2 className="tw-text-base tw-mb-0 tw-text-black tw-font-normal">Promoções encerradas</h2>
                    </header>
                    <div className="blockPromotions">
                        {this.props.closedPromotions.length > 0
                            ? this._showClosedPromotions()
                            : <Placeholder minHeight="300px" />}
                    </div>
                    {
                        this.props.closedPromotions.length > 0 && (
                            <PaginationComponent
                                currentPage={this.state.currentPage}
                                totalPages={Math.ceil(this.props.closedPromotions.length / (this.state.isMobile ? 4 : 8))}
                                onPageChange={this._handlePageChange}
                                handleNext={this._handleNext}
                                handlePrev={this._handlePrev}
                                isMobile={this.state.isMobile}
                            />
                        )
                    }
                </div>
            </section>
        );
    }
}

// @TODO define what is required and what not
Promotions.propTypes = exact({
    breakpoint: PropTypes.object,
    allPublishedPromotions: PropTypes.array,
    featuredPromotions: PropTypes.array,
    closedPromotions: PropTypes.array,
    fetchAllPublishedPromotionsIfNeeded: PropTypes.func,
    fetchClosedPromotionsIfNeeded: PropTypes.func,
    isTablet: PropTypes.string,
});

export default Promotions;
